// The module's public interface.
// Names absent here are module-private on purpose — add them only when a real consumer needs them.

export {
  hasFeature,
  hasRequiredFeature,
  supportsJoins,
} from "./utils/features";
